<template>
  <div class="controller">
    <ul class="action_buttons" v-if="!browsingAccountFlg">
      <li class="column_delete action_button" @click="deleteAction">
        {{ columnDelete }}
      </li>
      <li class="column_add action_button" v-if="!browsingAccountFlg">
        <router-link :to="router" class="add_router">
          {{ columnAdd }}
        </router-link>
      </li>
      <li
        class="csv_file_uploader column_import action_button"
        v-if="!browsingAccountFlg"
      >
        <label type="text" class="txt">{{ columnImport }}</label>
        <input
          type="file"
          size="2px"
          class="uploader"
          id="uploader"
          name="uploader"
          @change="fileUpload"
        />
      </li>
      <li
        class="column_export action_button"
        @click="exportAction"
        v-if="!browsingAccountFlg"
      >
        {{ columnExport }}
      </li>
    </ul>
    <div class="delete_modal_window" v-if="showDeleteModal">
      <deleteModalWindow
        :deleteList="checkedList"
        @close="closeModal"
        @remove="removeList"
      >
      </deleteModalWindow>
    </div>
    <div class="complete_modal_window" v-if="showCompleteModal">
      <completeModalWindow :question="completeWord" @close="closeModal">
      </completeModalWindow>
    </div>
    <div class="import_modal_window" v-if="showImportModal">
      <importModalWindow @close="closeModal" @import="importList">
      </importModalWindow>
    </div>
    <div class="export_modal_window" v-if="showExportModal">
      <exportModalWindow @close="closeModal" @export="exportList">
      </exportModalWindow>
    </div>
    <div class="export_modal_window" v-if="showCareworkerExportModal">
      <careworkerJobsModalWindow
        @close="closeModal"
        @export="exportListCareworker"
      >
      </careworkerJobsModalWindow>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <completeModalWindow :question="falseWord" @close="close">
      </completeModalWindow>
    </div>
  </div>
</template>

<script>
import deleteModalWindow from './modalWindow/allDeleteModalWindow.vue'
import completeModalWindow from './modalWindow/finishModalWindow.vue'
import importModalWindow from './modalWindow/importModalWindow.vue'
import exportModalWindow from './modalWindow/exportModalWindow.vue'
import careworkerJobsModalWindow from './modalWindow/selectExportJobsModalWindow.vue'

export default {
  props: ['dispItems', 'allItems', 'router'],
  data() {
    return {
      columnDelete: '削除',
      columnAdd: '追加',
      columnImport: 'インポート',
      columnExport: 'エクスポート',
      falseWord: '',
      completeWord: '',
      checkedList: [],
      showDeleteModal: false,
      showCompleteModal: false,
      showImportModal: false,
      showExportModal: false,
      showFalseModal: false,
      showCareworkerExportModal: false,
      inputValue: ''
    }
  },
  computed: {
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    browsingAccountFlg() {
      return this.$store.state.masters.browsingAccountFlg
    }
  },
  components: {
    deleteModalWindow,
    completeModalWindow,
    importModalWindow,
    exportModalWindow,
    careworkerJobsModalWindow
  },
  methods: {
    close(e) {
      this.showFalseModal = false
    },
    deleteAction(e) {
      // 削除対象のリストを作成し、確認モーダルを表示する
      this.checkedList = []
      this.setCheckedList()
      if (this.checkedList.length === 0) {
        this.showCompleteModal = true
        this.completeWord =
          this.errorMsg.MSGCRC0004.name + this.errorMsg.MSGCRC0004.value
      } else {
        this.showDeleteModal = true
      }
    },
    setCheckedList() {
      switch (location.pathname) {
        case '/devices':
        case '/devices/detail':
          this.checkedList = this.$store.state.devices.selectedDeviceList
          break
        case '/places':
        case '/places/detail':
          this.checkedList = this.$store.state.places.selectedLocationList
          break
        case '/belongs':
        case '/belongs/detail':
          this.checkedList = this.$store.state.belongs.selectedPostList
          break
        case '/careworkers':
        case '/careworkers/detail':
          this.checkedList =
            this.$store.state.careworkers.selectedCareworkerList
          break
        case '/adminAccounts':
        case '/adminAccounts/detail':
          this.checkedList = this.$store.state.adminAccounts.selectedAccountList
          break
        case '/auditLoggings':
        case '/auditLoggings/detail':
          this.checkedList = this.$store.state.auditLoggings.selectedLogList
          break
        case '/assigns':
        case '/assigns/detail':
          this.checkedList = this.$store.state.assigns.selectedAssignList
          break
        case '/reserve':
        case '/reserve/detail':
          this.checkedList = this.$store.state.reserve.selectedReserveList
          break
        case '/template':
        case '/template/detail':
          this.checkedList = this.$store.state.template.selectedTemplateList
          break
        case '/userNotification':
        case '/userNotification/detail':
          this.checkedList = this.$store.state.userNotification.selectedUserNotificationList
          break
      }
    },
    importAction(e) {
      // import用の確認モーダルを表示する
    },
    async exportAction(e) {
      // export用の確認モーダルを表示する
      // ケアワーカーの場合は別ダイアログ
      if (
        location.pathname === '/careworkers' ||
        location.pathname === '/careworkers/detail'
      ) {
        this.showloadingModal = true
        try {
          await this.$store.dispatch('careworkers/setJobs')
          this.showCareworkerExportModal = true
        } catch (error) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_230003
          if (error.response) {
            this.falseWord =
              this.errorMsg.MSGCRC0047.name +
              this.errorMsg.MSGCRC0047.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.falseWord =
              this.errorMsg.MSGCRC0005.name +
              this.errorMsg.MSGCRC0005.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          this.showFalseModal = true
        }
        this.showloadingModal = false
      } else {
        this.showExportModal = true
      }
    },
    closeModal(e) {
      this.showDeleteModal = false
      this.showCompleteModal = false
      this.showImportModal = false
      this.showExportModal = false
      this.showCareworkerExportModal = false
    },
    removeList(e) {
      this.$emit('remove', this.checkedList)
      this.showDeleteModal = false
    },
    importList(e) {
      this.showImportModal = false
      this.showCompleteModal = true
      this.completeWord = 'インポートしました。'
    },
    exportList(e) {
      this.showExportModal = false
      this.$emit('exportFile')
    },
    exportListCareworker(jobList) {
      this.showCareworkerExportModal = false
      this.$emit('exportFile', jobList)
    },
    fileUpload(e) {
      var result = e.target.files[0]
      if (result) {
        var fileReader = new FileReader()
        if (result.name.slice(-5) === '.xlsx') {
          fileReader.readAsArrayBuffer(result)
          fileReader.onload = () => {
            this.saveExcelData(fileReader.result)
          }
        } else {
          let eventNumber = this.$store.state.error.errorCode.errorCode_510003
          let eventType = 9
          let reason = 'MSGCRC0314'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.falseWord =
            this.errorMsg.MSGCRC0314.name +
            this.errorMsg.MSGCRC0314.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFalseModal = true
        }
      }
      e.target.value = ''
    },
    saveExcelData(buffer) {
      const data = new Uint8Array(buffer)
      this.$emit('import', data)
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/controller.vue